<template>
  <b-card
      title="مدیریت اتریبیوشن و ترکرها"
  >
    <b-row>
      <b-col
          class="table-size"
      >
        <div class="custom-search">
          <b-row>
            <div class="filter-row">
              <b-button
                  class="mb-1 ml-1 mr-auto"
                  variant="primary"
                  @click="showModal = true"
              >
                جدید
              </b-button>
              <b-col md="2">
                <b-form-group
                    label="عنوان"
                    label-for="Title"
                >
                  <b-form-input
                      v-model="filterOptions.Title"
                      @keyup.enter="update(1)"
                  />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="کمپین"
                    label-for="Campaign"
                    class="d-inline-block full-width"
                >
                  <campaign-select v-model="filterOptions.AdsCampaignId" auto-fetch />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                    label="کانال تبلیغاتی"
                    label-for="Channel"
                    class="d-inline-block full-width"
                >
                  <channel-select v-model="filterOptions.AdsChannelId" auto-fetch />
                </b-form-group>
              </b-col>
              <b-button
                  v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                  class="mb-1 mr-1"
                  variant="warning"
                  @click="update(1)"
              >فیلتر
              </b-button>
            </div>
          </b-row>
        </div>

        <b-table
            bordered
            hover
            striped
            :items="items"
            :fields="fields"
            class="mt-1 mb-2 position-relative"
            responsive
            :busy="loading"
        >
          <template #cell(AdsChannelId)="data">
            {{ (channels.find(a => a.Id === data.value) || {}).Title }}
          </template>

          <template #cell(AdsCampaignId)="data">
            {{ (campaigns.find(a => a.Id === data.value) || {}).Title }}
          </template>

          <template #cell(actions)="data">
            <div
                class="text-nowrap"
            >
              <feather-icon
                  icon="EditIcon"
                  size="16"
                  @click="edit(data.item)"
              />

              <feather-icon
                  icon="TrashIcon"
                  size="16"
                  class="ml-1 cursor-pointer"
                  @click="remove(data.item.Id)"
              />
            </div>
          </template>

          <template #table-busy>
            <div
                class="text-center my-2"
            >
              <b-spinner
                  variant="primary"
                  class="align-middle"
              />
              <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
            </div>
          </template>
        </b-table>

        <z-pagination
            :page="filterOptions.Page"
            :total-rows="totalRows"
            :loading="loading"
            @change="update"
        />
      </b-col>
    </b-row>
    <attribution-form
        :show.sync="showModal"
        :item="editingItem"
        :channels.sync="channels"
        :campaigns.sync="campaigns"
        @update="update"
    />
  </b-card>
</template>

<script>
import AttributionForm from "@/views/menu/campaign/attribution/attributionForm.vue";
import CampaignSelect from "@/tools/campaign.vue";
import ChannelSelect from "@/tools/channel.vue";
import { mapState } from "vuex";
export default {
  name: 'Attributions',
  components: { AttributionForm, CampaignSelect, ChannelSelect },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: false,
      formLoading: false,
      showModal: false,
      filterOptions: {
        Title: null,
        AdsCampaignId: null,
        AdsChannelId: null,
        Page: 1,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
        },
        {
          key: 'Title',
          label: 'عنوان',
        },
        {
          key: 'AdsChannelId',
          label: 'کانال تبلیغاتی',
        },
        {
          key: 'AdsCampaignId',
          label: 'کمپین',
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      editingItem: null
    }
  },
  computed: {
    ...mapState('zirehState', { campaigns: state => state.campaignSelect }),
    ...mapState('zirehState', { channels: state => state.channelSelect }),
  },
  watch: {
    showModal(val) {
      if (!val) this.editingItem = null
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
          this.$api.attributions.getlist, this.filterOptions,
      )
          .then(res => {
            this.totalRows = res.totalRow
            this.items = res.data
          })
          .finally(() => {
            this.loading = false
          })
    },
    edit(item) {
      this.editingItem = {
        Id: item.Id,
        AdsCampaignId: item.AdsCampaignId,
        AdsChannelId: item.AdsChannelId,
        AdtraceLink: item.AdtraceLink,
        AdtraceTrackerName: item.AdtraceTrackerName,
        MetrixLink: item.MetrixLink,
        MetrixTrackerName: item.MetrixTrackerName
      }
      this.showModal = true
    },
    remove(id) {
      this.removeRow(this.$api.attributions.remove, 'Id', id)
    },
  },
}
</script>